export const toneOptions = [
    "Professional",
    "Modern",
    "Creative",
    "Luxury",
    "Friendly",
    "Bold"
];

export const industryOptions = [
    "AI Services",
    "Software Development",
    "SaaS",
    "Healthcare",
    "Dental",
    "Legal",
    "Finance",
    "Real Estate",
    "Construction",
    "Interior Design",
    "Education",
    "Coaching",
    "Marketing Agency",
    "Recruitment",
    "Travel",
    "E-commerce",
    "Beauty & Salon",
    "Fitness & Gym",
    "Restaurant & Cafe",
    "Manufacturing",
    "Logistics",
    "Automobile",
    "Home Services",
    "Event Management",
    "Architecture",
    "Consulting",
    "NGO",
    "Personal Brand",
    "Photography",
    "Other"
];

export const subIndustryOptionsByIndustry = {
    "AI Services": [
        "AI Automation Agency",
        "AI Consulting",
        "Chatbot Services",
        "Custom AI Solutions",
        "AI Integration Services",
        "AI Development Company"
    ],

    "Software Development": [
        "Custom Software Development",
        "Web Development Agency",
        "Mobile App Development",
        "Product Development Studio",
        "Enterprise Software Services",
        "SaaS Development"
    ],

    "SaaS": [
        "CRM",
        "Workflow Automation",
        "Project Management",
        "HR Software",
        "Marketing Automation",
        "Sales Platform",
        "Analytics Platform",
        "AI SaaS"
    ],

    "Healthcare": [
        "Multi-specialty Clinic",
        "Diagnostic Center",
        "Physiotherapy Clinic",
        "Wellness Center",
        "Skin / Dermatology Clinic",
        "Pediatric Clinic",
        "General Practice Clinic"
    ],

    "Dental": [
        "Dental Clinic",
        "Cosmetic Dentistry",
        "Orthodontics",
        "Dental Implants",
        "Family Dentistry"
    ],

    "Legal": [
        "Law Firm",
        "Corporate Law",
        "Property Law",
        "Family Law",
        "Litigation",
        "Compliance Advisory",
        "Immigration Law"
    ],

    "Finance": [
        "Financial Advisory",
        "Accounting Firm",
        "Tax Consultancy",
        "Investment Advisory",
        "Loan / Mortgage Advisory"
    ],

    "Real Estate": [
        "Property Portal",
        "Builder / Developer",
        "Broker / Consultant",
        "Luxury Real Estate",
        "Commercial Real Estate",
        "Residential Projects"
    ],

    "Construction": [
        "Construction Company",
        "Builder",
        "Civil Contractor",
        "Infrastructure Projects",
        "Residential Construction"
    ],

    "Interior Design": [
        "Residential Interiors",
        "Commercial Interiors",
        "Luxury Interiors",
        "Turnkey Interiors",
        "Modular Design Studio"
    ],

    "Education": [
        "School",
        "Institute",
        "Coaching Center",
        "Training Academy",
        "Online Course Business",
        "Study Abroad Consultancy"
    ],

    "Coaching": [
        "Sports Coaching",
        "Football Academy",
        "Fitness Coaching",
        "Career Coaching",
        "Business Coaching",
        "Personal Development Coaching"
    ],

    "Marketing Agency": [
        "Digital Marketing Agency",
        "Performance Marketing",
        "SEO Agency",
        "Social Media Agency",
        "Branding Agency"
    ],

    "Recruitment": [
        "Staffing Agency",
        "Executive Search",
        "HR Consultancy",
        "Job Placement Services"
    ],

    "Travel": [
        "Travel Agency",
        "Tour Packages",
        "Visa Assistance",
        "Corporate Travel",
        "Holiday Planning"
    ],

    "E-commerce": [
        "Fashion Store",
        "Clothing Store",
        "Beauty Store",
        "Electronics Store",
        "Home Decor Store",
        "Jewelry Store",
        "Footwear Store",
        "Multi-category Store"
    ],

    "Beauty & Salon": [
        "Beauty Salon",
        "Hair Studio",
        "Skin Clinic",
        "Spa & Wellness",
        "Bridal Makeup Studio"
    ],

    "Fitness & Gym": [
        "Gym",
        "Personal Training Studio",
        "Yoga Studio",
        "CrossFit Gym",
        "Fitness Academy"
    ],

    "Restaurant & Cafe": [
        "Cafe",
        "Fine Dining Restaurant",
        "Fast Food Outlet",
        "Cloud Kitchen",
        "Bakery"
    ],

    "Manufacturing": [
        "Industrial Manufacturing",
        "Consumer Goods Manufacturing",
        "Textile Manufacturing",
        "Packaging Manufacturing"
    ],

    "Logistics": [
        "Freight Services",
        "Courier Services",
        "Warehouse & Fulfillment",
        "Transport Company"
    ],

    "Automobile": [
        "Car Dealership",
        "Auto Service Center",
        "Bike Showroom",
        "Auto Parts Business"
    ],

    "Home Services": [
        "Cleaning Services",
        "Plumbing Services",
        "Electrical Services",
        "Repair Services",
        "Pest Control"
    ],

    "Event Management": [
        "Wedding Planning",
        "Corporate Events",
        "Birthday Events",
        "Exhibition Management"
    ],

    "Architecture": [
        "Architectural Firm",
        "Urban Design Studio",
        "Residential Architecture",
        "Commercial Architecture"
    ],

    "Consulting": [
        "Business Consulting",
        "Management Consulting",
        "Financial Consulting",
        "Growth Consulting",
        "Strategy Advisory"
    ],

    "NGO": [
        "Education NGO",
        "Healthcare NGO",
        "Women Empowerment NGO",
        "Rural Development NGO"
    ],

    "Personal Brand": [
        "Coach / Mentor",
        "Speaker",
        "Creator",
        "Consultant",
        "Influencer Brand"
    ],

    "Photography": [
        "Wedding Photography",
        "Portrait Photography",
        "Commercial Photography",
        "Studio Photography"
    ],

    "Other": []
};

export const ctaOptions = [
    "Book a Call",
    "Get a Quote",
    "Contact Us",
    "Schedule Consultation",
    "Start Free Trial",
    "Request Demo",
    "Get Started",
    "Buy Now",
    "Send Inquiry",
    "View Portfolio",
    "See Pricing",
    "WhatsApp Now",
    "Download Brochure",
    "Join Now"
];

export const brandStyleOptions = [
    "Premium",
    "Minimal",
    "Corporate",
    "Bold",
    "Luxury",
    "Modern",
    "Futuristic",
    "Elegant",
    "Friendly",
    "High-Trust",
    "Startup",
    "Creative"
];

export const pricePositioningOptions = [
    "Budget",
    "Affordable",
    "Mid-Market",
    "Premium",
    "Luxury"
];

export const goalOptions = [
    "Generate Leads",
    "Book Appointments",
    "Drive Sales",
    "Showcase Portfolio",
    "Build Trust",
    "Brand Awareness",
    "Get Demo Requests",
    "Capture Emails",
    "Promote Service",
    "Launch Product",
    "Drive WhatsApp Inquiries",
    "Increase Phone Calls"
];

export const websiteTypeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Property Portal / Listings", value: "portal" },
    { label: "Business / Company Website", value: "company" },
    { label: "Builder / Developer", value: "builder" },
    { label: "Academy / Institute", value: "academy" },
    { label: "Store / Shop", value: "store" },
    { label: "Agency", value: "agency" },
    { label: "SaaS Product / Platform", value: "saas" },
    { label: "Clinic / Healthcare Center", value: "clinic" },
    { label: "Law Firm / Legal Practice", value: "legal-firm" }
];

export const websiteModeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Search & Discovery", value: "search-discovery" },
    { label: "Lead Generation", value: "lead-generation" },
    { label: "Brand Showcase", value: "brand-showcase" },
    { label: "Catalog / Browse", value: "catalog" },
    { label: "Admissions / Enquiries", value: "admissions" },
    { label: "Demo / Trial Conversion", value: "demo-conversion" },
    { label: "Appointment Booking", value: "appointment-booking" },
    { label: "Consultation First", value: "consultation-first" }
];

export const entityTypeOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Properties / Listings", value: "property" },
    { label: "Programs / Courses", value: "program" },
    { label: "Products", value: "product" },
    { label: "Services", value: "service" },
    { label: "Features / Modules", value: "feature" },
    { label: "Doctors / Treatments", value: "healthcare" },
    { label: "Practice Areas / Lawyers", value: "legal" }
];

export const locationFocusOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "City Focused", value: "city-first" },
    { label: "Area / Locality Focused", value: "locality-first" },
    { label: "Statewide", value: "statewide" },
    { label: "National", value: "national" }
];

export const websiteFeelOptions = [
    { label: "Auto (AI Decide)", value: "" },
    { label: "Utility Dense", value: "utility-dense" },
    { label: "Premium Minimal", value: "premium-minimal" },
    { label: "Trust Focused", value: "trust-heavy" },
    { label: "Conversion Focused", value: "conversion-first" },
    { label: "Product Led", value: "product-led" },
    { label: "Care Focused", value: "care-first" },
    { label: "Authority Focused", value: "authority-first" }
];

export const getRecommendedPages = (
    industry,
    subIndustry,
    businessModel = "",
    primaryWebsiteMode = ""
) => {
    const text = `${industry} ${subIndustry} ${businessModel} ${primaryWebsiteMode}`.toLowerCase();

    if (
        text.includes("real estate") ||
        text.includes("property") ||
        text.includes("portal") ||
        text.includes("listing") ||
        text.includes("search-discovery")
    ) {
        return ["Home", "Listings", "Localities", "Contact"];
    }

    if (
        text.includes("sports") ||
        text.includes("academy") ||
        text.includes("training") ||
        text.includes("education") ||
        text.includes("school") ||
        text.includes("course") ||
        text.includes("admissions")
    ) {
        return ["Home", "Programs", "Coaches", "Contact"];
    }

    if (
        text.includes("e-commerce") ||
        text.includes("ecommerce") ||
        text.includes("store") ||
        text.includes("shop") ||
        text.includes("catalog")
    ) {
        return ["Home", "Products", "Collections", "Contact"];
    }

    if (
        text.includes("saas") ||
        text.includes("software") ||
        text.includes("platform") ||
        text.includes("crm") ||
        text.includes("automation")
    ) {
        return ["Home", "Features", "Pricing", "Contact"];
    }

    if (
        text.includes("healthcare") ||
        text.includes("clinic") ||
        text.includes("medical") ||
        text.includes("dental") ||
        text.includes("doctor") ||
        text.includes("wellness")
    ) {
        return ["Home", "Treatments", "Doctors", "Contact"];
    }

    if (
        text.includes("legal") ||
        text.includes("law") ||
        text.includes("law firm") ||
        text.includes("advocate") ||
        text.includes("attorney")
    ) {
        return ["Home", "Practice Areas", "Team", "Contact"];
    }

    return ["Home", "About", "Services", "Contact"];
};